

import { Box } from '@wix/design-system';
import React, { FunctionComponent, useContext } from 'react';

import { LoggedIn } from './LoggedIn';
import { NotLoggedIn } from './NotLoggedIn';
import { SearchBarModal } from './SearchBarModal';
import { Context } from '../../../context';
import { useIxWixelRelated } from '../../../hooks/useIsWixelRelated';

export const HeaderRight: FunctionComponent = () => {
  const { isLoggedInUser } = useContext(Context);
  const shouldHideSearchBar = useIxWixelRelated();

  return (
    <Box gap={2}>
      {!shouldHideSearchBar && <SearchBarModal />}
      {!isLoggedInUser ? (
        <NotLoggedIn />
      ) : (
        <LoggedIn />
      )}
    </Box>
  );
};
